/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Client, RequestConfig, ResponseErrorConfig } from '@eureca/candidate-api-sdk/client';
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query';
import type {
  PostMyIdentityConfirmationMutationRequest,
  PostMyIdentityConfirmationMutationResponse,
  PostMyIdentityConfirmation401,
  PostMyIdentityConfirmation403,
  PostMyIdentityConfirmation409,
  PostMyIdentityConfirmation422,
  PostMyIdentityConfirmation429,
  PostMyIdentityConfirmation502,
  PostMyIdentityConfirmation503,
} from '../types/PostMyIdentityConfirmation.ts';
import { mutationOptions, useMutation } from '@tanstack/react-query';
import { postMyIdentityConfirmation } from '../clients/postMyIdentityConfirmation.ts';

export const postMyIdentityConfirmationMutationKey = () =>
  [{ url: '/me/identity-confirmation' }] as const;

export type PostMyIdentityConfirmationMutationKey = ReturnType<
  typeof postMyIdentityConfirmationMutationKey
>;

export function postMyIdentityConfirmationMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostMyIdentityConfirmationMutationRequest>> & {
    client?: Client;
  } = {}
) {
  const mutationKey = postMyIdentityConfirmationMutationKey();
  return mutationOptions<
    PostMyIdentityConfirmationMutationResponse,
    ResponseErrorConfig<
      | PostMyIdentityConfirmation401
      | PostMyIdentityConfirmation403
      | PostMyIdentityConfirmation409
      | PostMyIdentityConfirmation422
      | PostMyIdentityConfirmation429
      | PostMyIdentityConfirmation502
      | PostMyIdentityConfirmation503
    >,
    { data: PostMyIdentityConfirmationMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postMyIdentityConfirmation(data, config);
    },
  });
}

/**
 * {@link /me/identity-confirmation}
 */
export function usePostMyIdentityConfirmation<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostMyIdentityConfirmationMutationResponse,
      ResponseErrorConfig<
        | PostMyIdentityConfirmation401
        | PostMyIdentityConfirmation403
        | PostMyIdentityConfirmation409
        | PostMyIdentityConfirmation422
        | PostMyIdentityConfirmation429
        | PostMyIdentityConfirmation502
        | PostMyIdentityConfirmation503
      >,
      { data: PostMyIdentityConfirmationMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostMyIdentityConfirmationMutationRequest>> & {
      client?: Client;
    };
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postMyIdentityConfirmationMutationKey();

  const baseOptions = postMyIdentityConfirmationMutationOptions(config) as UseMutationOptions<
    PostMyIdentityConfirmationMutationResponse,
    ResponseErrorConfig<
      | PostMyIdentityConfirmation401
      | PostMyIdentityConfirmation403
      | PostMyIdentityConfirmation409
      | PostMyIdentityConfirmation422
      | PostMyIdentityConfirmation429
      | PostMyIdentityConfirmation502
      | PostMyIdentityConfirmation503
    >,
    { data: PostMyIdentityConfirmationMutationRequest },
    TContext
  >;

  return useMutation<
    PostMyIdentityConfirmationMutationResponse,
    ResponseErrorConfig<
      | PostMyIdentityConfirmation401
      | PostMyIdentityConfirmation403
      | PostMyIdentityConfirmation409
      | PostMyIdentityConfirmation422
      | PostMyIdentityConfirmation429
      | PostMyIdentityConfirmation502
      | PostMyIdentityConfirmation503
    >,
    { data: PostMyIdentityConfirmationMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    PostMyIdentityConfirmationMutationResponse,
    ResponseErrorConfig<
      | PostMyIdentityConfirmation401
      | PostMyIdentityConfirmation403
      | PostMyIdentityConfirmation409
      | PostMyIdentityConfirmation422
      | PostMyIdentityConfirmation429
      | PostMyIdentityConfirmation502
      | PostMyIdentityConfirmation503
    >,
    { data: PostMyIdentityConfirmationMutationRequest },
    TContext
  >;
}
